import React from "react";
import { api } from "@/lib/config";
import { useNavigate } from "react-router-dom";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = React.useRef(false);

  React.useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/admin/login", { replace: true }); return; }
    (async () => {
      try {
        const res = await api.get(`/auth/callback?session_id=${encodeURIComponent(sessionId)}`);
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data.user } });
      } catch {
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-[color:var(--brand-woodDark)]">
      Signing you in...
    </div>
  );
}
